import { render, staticRenderFns } from "./UserActivityRecordList.vue?vue&type=template&id=3f87fd78&scoped=true&lang=pug&"
import script from "./UserActivityRecordList.vue?vue&type=script&lang=ts&"
export * from "./UserActivityRecordList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f87fd78",
  null
  
)

export default component.exports